export default "__VITE_PUBLIC_ASSET__0c98cf28__"